import * as React from "react";
import DoneIcon from '@material-ui/icons/Done';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';

import './Notification.scss';
import gql from 'graphql-tag';
import { Mutation, ChildProps } from 'react-apollo';
import { styles } from './styles';
import { INotificationQuery, NOTIFICATION_QUERY } from './Notification';
import Rest from "../../../../services/Rest";
import FileUtils from "../../../../services/FileUtils";
import * as path from 'path';

const READ_NOTIFICATION_QUERY = gql`
mutation readNotification($notificationId: ID!){
  readNotification(notificationId: $notificationId){
    id,message,meta,date_send,date_read,read
  }
}
`;

export interface INotificationPopoverProps {
  classes?: any,
  handleClose?: any,
  anchorEl?: HTMLElement,
  notifications: INotificationQuery[]
}

// tslint:disable-next-line:no-empty-interface
export interface INotificationPopover {
}

export const NotificationPopover =  withStyles(styles)<INotificationPopoverProps>(
  class extends React.Component<INotificationPopoverProps & WithStyles<'badgeNotification'>, INotificationPopover> {
    constructor(props: INotificationPopoverProps & WithStyles<'badgeNotification'>) {
      super(props);
      this.state = {
        anchorEl: undefined,
      };
    }

    public render() {
      const { classes } = this.props;
      const open = Boolean(this.props.anchorEl);

      return (
        <div className="notification-component">
          <Popover
            id="simple-popper"
            open={open}
            anchorEl={this.props.anchorEl}
            onClose={this.props.handleClose}
            anchorOrigin={{
              horizontal: 'left',
              vertical: 'top',
            }}
          >
            <List component="nav">
              { this.props.notifications &&
                this.props.notifications.map((item: INotificationQuery, key: number) => {
                  return (
                    <Mutation mutation={READ_NOTIFICATION_QUERY} key={key} >
                      { (updateMsg, {loading, error}) => (
                        <ListItem button={true} onClick={ this.handleClick.bind(this, updateMsg, item.id, item.meta ? JSON.parse(item.meta):null) }>
                          <Grid container={true} spacing={8}>
                            <Grid item={true} xs={11}>
                              <span className={classes.itemText}>
                                {item.message}
                              </span>
                            </Grid>
                            <Grid item={true} xs={1}>
                              <span className={item.read ? '' : 'dot'} />
                            </Grid>
                            <Grid item={true} xs={9} className={classes.itemText}>
                              <DoneIcon className={classes.readyIcon}/>
                              <span className={classes.readyMsg}>
                                Pronto para baixar
                              </span>
                            </Grid>
                            <Grid item={true} xs={3} className={classes.relative}>
                              <span className={classes.dateMsg}>
                                { new Date( item.date_send ).toISOString().split('T')[0].split('-').reverse().join('/') }
                              </span>
                            </Grid>
                          </Grid>
                        </ListItem>
                      )}
                    </Mutation>
                  )
              })}
            </List>
          </Popover>
        </div>
      );
    }

    private handleClick(updateMsg: ChildProps<any>, itemId: number, meta:any){
      updateMsg({
        update: (cache: any) => {
          const data = cache.readQuery({query: NOTIFICATION_QUERY});

          for (const i in data.getNotifications) {
            if (data.getNotifications[i].id === itemId) {
              data.getNotifications[i].flag_lido = true;
            }
          }

          cache.writeQuery({query: NOTIFICATION_QUERY, data});
        },
        variables: {notificationId: itemId}
      }).then(() => {
        if(meta) {
          const baseName = path.basename(meta.url);
          this.downloadSheet(baseName);
        }
        this.props.handleClose();
      });
    }
    
    private downloadSheet(baseName: string) {
      Rest.GET('analysis-file', baseName).then(response => {
        if (response.ok && response.body) {
            FileUtils.downloadXlsx(response.body, decodeURIComponent(baseName));
        } else {
          console.log('O arquivo solicitado não encontra-se mais disponível')
          throw [response.status, response.statusText]
        }
      })
    }
  }
)



// WEBPACK FOOTER //
// ./src/component/shared/layout/notification/NotificationPopover.tsx